import { createRouter, createWebHistory } from 'vue-router';
import BeneficiariesRoutes from './beneficiaries-routes.js';
import AdminRoutes from './admin-routes.js';
import AdvisorRoutes from './advisor-routes.js';
import { handleChunkLoadError, clearChunkReloadFlag } from './handleChunkLoadError';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Authentication/Login.vue'),
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: () => import('../views/Authentication/ResetPassword.vue'),
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('../views/Authentication/ForgotPassword.vue'),
    },
    {
      path: '/magic-link/:token',
      name: 'MagicLink',
      component: () => import('../views/MagicLinkAuthentication/MagicLinkAuthentication.vue'),
    },
    {
      path: '/password-setup/:token',
      name: 'PasswordSetup',
      component: () => import('../views/Authentication/PasswordSetup.vue'),
    },
    AdminRoutes,
    BeneficiariesRoutes,
    AdvisorRoutes,
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: () => import('../views/Authentication/AccessDenied.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/NotFound/NotFound.vue'),
    },
  ],
});

router.onError((error, to) => {
  handleChunkLoadError(error, to);
});

router.afterEach(() => {
  clearChunkReloadFlag();
});

export default router;
